import { createContext } from 'utils/react/createContext';
import { UsePopoverReturn } from '../UsePopover';

export const [PopoverContext, usePopoverContext] =
  createContext<UsePopoverReturn>();
